module.exports = __webpack_public_path__ + "media/images/img/banner/bnr_book202004-34136ed67a7e3797441e87b03b931a44.jpg";